import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { bounceIn } from "src/app/animations/custom.animation";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-takeover-page",
    templateUrl: "./takeover-page.component.html",
    styleUrls: ["./takeover-page.component.css"],
    animations: [bounceIn],
    standalone: true,
    imports: [IonicModule],
})
export class TakeoverPageComponent implements OnInit {
  public messageData: Data;
  backgroundImage: string;
  constructor(
    private bottomSheet: MatBottomSheetRef<TakeoverPageComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    private authService: AuthService,
    public translate: TranslateService,
    private router: Router
  ) {
    this.messageData = data?.message;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.backgroundImage =
    this.messageData?.template_data?.top_background_url != ""
    ? this.messageData?.template_data?.top_background_url
    : "";
  }

  ngOnInit(): void {
    //
  }

  back() {
    this.bottomSheet.dismiss();
  }

  onCTA() {
    this.bottomSheet.dismiss();
    this.router.navigate([this.messageData?.destination]);
  }
}
